var map = {
	"./Graduation_logo.png": 5448,
	"./computer-image1.jpg": 8118,
	"./computer-image2.jpg": 8465,
	"./cpu-image.jpg": 352,
	"./download.png": 852,
	"./facebook.svg": 6338,
	"./inputs-devices-image.jpg": 7937,
	"./linkedin.svg": 7464,
	"./motherboard-image-2.jpg": 2740,
	"./motherboard-image.jpg": 4729,
	"./outout-device-image.jpg": 8741,
	"./ram-image.jpg": 2854,
	"./retro-computer-image.jpg": 4318,
	"./storage-device-image-2.jpg": 6399,
	"./storage-device-image-3.jpg": 3730,
	"./storage-device-image-4.jpg": 2961,
	"./storage-device-image.jpg": 2250,
	"./whatsapp-svgrepo-com.svg": 5073,
	"./youtube.svg": 8549
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;